import { useContext } from 'react';
import { Link as Component } from 'react-router-dom';
import { LoaderContext } from '../context';

export const Link = (props) => {
    const {changePage} = useContext(LoaderContext)
   return <Component onClick={changePage}  {...props} >
    {props.children}
  </Component>
}